// Type of action for tracking user
export const SAVE_USER_ACTION = 'SAVE_USER_ACTION';